import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCheck,
  faAngleDown,
  faEllipsisH,
} from "@fortawesome/pro-light-svg-icons";

function EnrollmentAndEligibilityAnalyticsComponent(props) {
  return (
    <div
      style={{
        background: "white",
        width: "100%",
        borderRadius: "5px",
        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1)",
        padding: "15px 20px",
      }}
    >
      <div
        className="d-flex"
        style={{ fontSize: "16px", fontWeight: "500", width: "100%" }}
      >
        <div>Eligibility & Enrollment Analytics</div>
        <div className="ml-auto" style={{ color: "grey" }}>
          <FontAwesomeIcon icon={faEllipsisH} />
        </div>
      </div>
    </div>
  );
}

export default EnrollmentAndEligibilityAnalyticsComponent;
